export const EXCHANGE_RATE_API_URL = 'https://open.exchangerate-api.com/v6/latest';
export const CURRENCIES_RATE_API_URL = 'https://openexchangerates.org/api/currencies.json';
export const MAX_RETRIES = 3;
export const BASE_DELAY_MS = 1000;
